import React from 'react'
import { PostWrite } from '../../components/components'
import './home.css'
import WhatsHappening from './WhatsHappening'

function Home() {
  return (
    <div className="WhatsHappening">
      <div className="col-lg-6 col-12">
        <PostWrite />
        <WhatsHappening />
      </div>
    </div>
  )
}

export default Home
